__turbopack_context__.v({
  "toggle": "theme-toggle-module__5osq2q__toggle",
});
